import type { OnboardingTourStepOption } from 'models';
import { useResetQueryMutation } from 'query';
import { useMemo } from 'react';
import { useLogout } from 'common/services/hooks';
import { OnboardingTour, OnboardingTourImage, OnboardingTourLayout } from 'features/onboarding';
import { useOnSuccessLogin } from '../hooks';
import { useOnboardingTourStep } from './hooks';

const STEP_KEY = 'step';

export type OnboardingTourLocationState = {
  originalState?: unknown;
  referrer?: string;
};

const PageOnboardingTour = () => {
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onSuccessOnboardingTour } = useOnSuccessLogin();
  const { onChangeStep, step } = useOnboardingTourStep({ stepKey: STEP_KEY });
  const { mutateAsync: resetQuery } = useResetQueryMutation();

  const onLogout = useLogout();

  const isCenteredStep = useMemo(() => {
    const centeredSteps: Array<OnboardingTourStepOption | undefined> = [undefined, 'intro', 'finish'];
    return centeredSteps.includes(step);
  }, [step]);

  const onFinish = async () => {
    await resetQuery({ cacheResetOption: 'reset' });
    await onSuccessOnboardingTour();
  };

  return (
    <OnboardingTourLayout
      centeredContent={isCenteredStep}
      contentLeft={() => <OnboardingTourImage step={step} />}
      contentRight={({ steps, viewer }) => (
        <OnboardingTour
          onChangeStep={onChangeStep}
          onFinish={onFinish}
          onLogout={onLogout}
          step={step}
          steps={steps}
          viewer={viewer}
        />
      )}
    />
  );
};

export default PageOnboardingTour;
